export default __webpack_public_path__ + "static/media/electrical.bc456c2f.svg";